import { detailedCoastlines } from '../static/bigVars/coastlines';

// Function to convert geographic coordinates to scatterplot coordinate system
const geoToScatterCoords = (lon, lat) => {
    // convert longitude (-180 to 180) to x (-1 to 1)
    const x = (lon + 180) / 360 * 2 - 1;
    // convert latitude (-90 to 90) to y (-1 to 1) and apply vertical flattening
    const y = (lat + 90) / 180 * 2 - 1;
    // apply the same flattening factor as in the API (1.48)
    const flattenedY = y / 1.48;
    return [x, flattenedY];
};

export const generateCoastlineAnnotations = (theme) => {
    // const coastlineColor = theme.name === 'light' ? [0.3, 0.3, 0.3, 0.8] : [0.7, 0.7, 0.7, 0.8];
    const coastlineColor = theme.name === 'light' ? [0.1, 0.1, 0.1, 0.9] : [0.7, 0.7, 0.7, 0.8];
    const gridColor = theme.name === 'light' ? [0.8, 0.8, 0.8, 0.3] : [0.3, 0.3, 0.3, 0.5];
    const annotations = [];

    // add coastlines as polygons/lines using vertices
    detailedCoastlines.forEach(coastline => {
        const vertices = coastline.map(([lon, lat]) => geoToScatterCoords(lon, lat));

        annotations.push({
            vertices,
            lineColor: coastlineColor,
            lineWidth: 0.5
        });
    });

    // // add major latitude lines (grid) - use horizontal line format
    // for (let lat = -60; lat <= 60; lat += 30) {
    //     const [, y] = geoToScatterCoords(0, lat);
    //     annotations.push({
    //         y,
    //         lineColor: gridColor,
    //         lineWidth: 0.3
    //     });
    // }

    // // add major longitude lines (grid) - use vertical line format
    // for (let lon = -180; lon <= 180; lon += 60) {
    //     const [x] = geoToScatterCoords(lon, 0);
    //     annotations.push({
    //         x,
    //         lineColor: gridColor,
    //         lineWidth: 0.3
    //     });
    // }

    // // add equator - use horizontal line format
    // const [, eqY] = geoToScatterCoords(0, 0);
    // annotations.push({
    //     y: eqY,
    //     lineColor: coastlineColor,
    //     lineWidth: 0.4
    // });

    // // add prime meridian - use vertical line format
    // const [pmX] = geoToScatterCoords(0, 0);
    // annotations.push({
    //     x: pmX,
    //     lineColor: coastlineColor,
    //     lineWidth: 0.4
    // });

    return annotations;
};